import React from 'react';

const PasswordVisibleIcon: React.FunctionComponent = () => {
  return (
    <svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 7.5S4.273 1 10 1s9 6.5 9 6.5-3.273 6.5-9 6.5-9-6.5-9-6.5"
        stroke="#865CD0"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 10.286c1.491 0 2.7-1.247 2.7-2.786S11.491 4.714 10 4.714 7.3 5.961 7.3 7.5s1.209 2.786 2.7 2.786"
        stroke="#865CD0"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PasswordVisibleIcon;
